import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "components/Spinner";
import { useCreateArtworkCollectionStore } from "../../artwork/context/collection/create/CreateArtworkCollectionContext";
import { CreateCollectionActions } from "../../artwork/state/collection/create";
import { CreateArtworkCollectionTypes } from "../../artwork/state/collection/create/data";

export const ArtworkPictureModal = ({
  handleCloseModal,
  product,
  isLoading = false,
  setImage
}: {
  handleCloseModal: any;
  product: any;
  isLoading?: boolean;
  setImage: (image:any) => void
}) => {
  // const { state, dispatch } = useCreateArtworkCollectionStore();

  return (
    <>
      <div className="p-2">
        <div className="d-flex justify-content-between mb-1">
          <div className="col-4"></div>
          {!isLoading && (
            <h3 className="h5 text-center col-md-4">
              <strong>Picture - {product.imageName}</strong>
            </h3>
          )}
          <div className="col-md-4 d-flex justify-content-end">
            <button
              onClick={handleCloseModal}
              className="icon-button close-cross"
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center px-3 mx-3 ">
          {isLoading && <Spinner />}
          {!isLoading && (
            <>
              {/*{product.image_file && (*/}
              {/*  <img*/}
              {/*    src={*/}
              {/*      //@ts-ignore*/}
              {/*      URL.createObjectURL(product.image_file)*/}
              {/*    }*/}
              {/*    className="mb-3 d-block"*/}
              {/*    height={300}*/}
              {/*    alt="product"*/}
              {/*  />*/}
              {/*)}*/}
              <img
                src={
                  product?.image_file ?
                    //@ts-ignore
                    URL.createObjectURL(product.image_file) : product?.image_base64
                }
                className="mb-3 d-block"
                height={300}
                alt="product"
              />
              <div className="d-flex w-100 justify-content-between">
                <div className="col-4"></div>
                <p className="text-center col-4">Not to Scale</p>
                <p className="text-right col-4">{`Source: ${
                  product?.image_url ? "Bynder" : "Moldapp"
                }`}</p>
              </div>

              {!product.isBlocked &&
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => {
                  setImage("")
                  handleCloseModal();
                }}
              >
                Remove
              </button>
              }
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ArtworkPictureModal;
